import type { FaireProductEntity } from "../../entity_types/product";

export const p_3vk2tnzd28: FaireProductEntity = {
  token: "p_3vk2tnzd28",
  type: "product",
  name: "The Big Three Bundle",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/00a49f75bb6870bd9c8cbfda10888068ac988215133b3eb2581f047a8efcd577.jpeg",
  galleryImageUrls: [],
  priceDollars: 193,
  description: "This bundle includes 3 cases total (72 individual cans), 1 case of each of our mainstay flavors: Southern Style, Field Day, and Greetings From. \n\nSouthern Style-Lemon & Thyme: \nOur take on an Arnold Palmer. We swapped the tea for coffee and added bubbles to give you a delicious and fun way to enjoy these classic flavors.\n\nField Day-Strawberry & Lime: \nRemember your favorite juice pouch from childhood? Well, imagine it now with coffee and bubbles for a fun new way to enjoy the flavors you already know and love.\n\nGreetings From-Passion Fruit:\nDeep tropical flavors with a hint of sea salt. Whether you’re traveling abroad or on a joy ride at home, the final product will make you feel like you’re ocean-side no matter where you are.\n\nEnjoyed best chilled or over ice. Any of these coffee sodas make for a delicious and unique ready-to-drink clean caffeine option, mocktail, or cocktail mixer. \n\n\n",
  tags: [],
  msrpDollars: 279.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:33.552Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
